import { render, staticRenderFns } from "./_baseTable.vue?vue&type=template&id=5529a63f&scoped=true&"
import script from "./_baseTable.vue?vue&type=script&lang=js&"
export * from "./_baseTable.vue?vue&type=script&lang=js&"
import style0 from "./_baseTable.vue?vue&type=style&index=0&id=5529a63f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5529a63f",
  null
  
)

export default component.exports